import React from "react";

interface IProps {
  title: string;
  Icon: any;
}

const BasketMoreButton: React.FC<IProps> = ({ title, Icon }: IProps) => {
  return (
    <>
      <p>{title}</p>
      <Icon className={`io-ios-arrow red-class`} />
    </>
  );
};

export default BasketMoreButton;
